import React, { Fragment } from 'react';

import useClubFacilitiesPoolsDetail from './UseClubFacilitiesPoolsDetail';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import AddEditFacilityPool from '@usas/ui-web/components/searches/searchFacility/addEditPool/AddEditFacilityPool';
import Constants from '@usas/ui-web/utils/Constants';

import NavLinks from '../NavLinks';

const ClubFacilitiesPoolsDetail = () => {
  const {
    usasClubFacilityLinksState
  } = useClubFacilitiesPoolsDetail();

  return (
    <Fragment>
      <AddEditFacilityPool
        saveUrl={NavLinks.CLUB_FACILITIES}
        cancelUrl={NavLinks.CLUB_FACILITIES}
        showFacilityInfo={true} />
      <div className="row">
        <div className="col-xs-12 usas-extra-bottom-margin"></div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={usasClubFacilityLinksState.isSaving} />
    </Fragment>
  );
};

export default ClubFacilitiesPoolsDetail;